import React, { forwardRef } from 'react';
import TableCell from './TableCell';
import classes from '../ScoreboardTable.module.css';

const TableRow = forwardRef(({ row, rowIndex, columns = [], isActive = false }, ref) => {
    return (
        <div ref={ref} className={`${classes.tr} ${isActive ? classes.trActive : ''} ${classes.rowFlex}`} role="row">
            {columns.map((column) => {
                const cellValue = row[column.key];
                return (
                    <div key={column.key} className={`${classes.td} ${column.cssClass}`} role="cell">
                        <TableCell value={cellValue} row={row} column={column} rowIndex={rowIndex} />
                    </div>
                );
            })}
        </div>
    );
}
);

TableRow.displayName = 'TableRow';
export default TableRow;
